<template lang="html">

  <div class="infoText">
          <table>
              <tr>
                  <td class="tbName">楼宇名称</td>
                  <td colspan="3" class="tbContent">{{buildingInfos.buildingName}}</td>
              </tr>
              <tr>
                  <td class="tbName">物业单位</td>
                  <td class="tbContent">{{buildingInfos.tenement}}</td>
                  <td class="tbName">产权单位</td>
                  <td class="tbContent">{{buildingInfos.propertyUnit}}</td>
              </tr>

              <tr>
                  <td class="tbName">所在街乡</td>
                  <td>{{buildingInfos.jiexiang}}</td>
                  <td class="tbName">地址</td>
                  <td>{{buildingInfos.address}}</td>
              </tr>

              <tr>
                  
                  <td class="tbName">所属功能区</td>
                  <td>{{buildingInfos.park}}</td>
                  <td class="tbName">项目类型</td>
                  <td>{{buildingInfos.projectType}}</td>
              </tr>

              <tr>
                  
                  <td class="tbName">是否国有</td>
                  <td>{{buildingInfos.nationalized}}</td>
                  <td class="tbName">产业定位</td>
                  <td>{{buildingInfos.location}}</td>
              </tr>

              <tr>
                  <td class="tbName">是否愿意在市级平台对外发布推介</td>
                  <td>{{buildingInfos.isWillingCityPlatformReleaseRecommend}}</td>
                  <td class="tbName">是否愿意在区级招商工作中对外发布推介</td>
                  <td>{{buildingInfos.isWillingDistrictInvestmentWorkeleaseRecommend}}</td>
              </tr>
                <tr>
                  <td class="tbName">不希望对外发布的原因</td>
                  <td>{{buildingInfos.notPublishReason}}</td>
                  <td class="tbName">是否愿意承接国际组织办公场所</td>
                  <td>{{buildingInfos.isWillingUndertakeInterOrganizationWorkspace}}</td>
              </tr>
                <tr>
                  <td class="tbName">规划建筑面积(平方米)</td>
                  <td>{{buildingInfos.planBuildingArea}}㎡</td>
                  <td class="tbName">当前空置可招商面积</td>
                  <td>{{buildingInfos.totalVacantArea}}㎡</td>
              </tr>

              <tr>
                  <td class="tbName">招商负责人</td>
                  <td>{{buildingInfos.leadingCadre}}</td>
                  <td class="tbName">负责人手机号</td>
                  <td>{{buildingInfos.leadingCadrePhone}}</td>
              </tr>
              <tr>
                  <td class="tbName">负责人邮箱</td>
                  <td>{{buildingInfos.leadingCadreEmail}}</td>
                  <td class="tbName">周边交通情况</td>
                  <td>{{buildingInfos.trafficCondition}}</td>
                  
              </tr>
              <tr>
                  <td class="tbName">周边公共配套情况</td>
                  <td>{{buildingInfos.supportingSituation}}</td>
                  <td class="tbName">其他补充说明</td>
                  <td colspan="3">{{buildingInfos.other}}</td>
              </tr>
          </table>

      <div class="imgs">
          <div class="imgTtl">楼宇图片</div>
          <imgsView :files="buildingInfos.image" />
      </div>
  </div>

</template>

<script>
import { getBuildingInfos } from '@/api/industryInfos';
import imgsView from '../imgsUpload';
export default {
   components:{
       imgsView
   },
   data(){
       return{
           buildingInfos:{}
       }
   },
   created(){
       let querys = this.$route.query;
       getBuildingInfos({id:querys.id}).then(res => {
           this.buildingInfos = res.industrialSpace;
       });
   }
}
</script>

<style lang="scss" scoped>

.infoText{
    table{
        width: 100%;
        font-size: 14px;
        border-collapse: collapse;

        td{
            padding: 12px;
            box-sizing: border-box;
            border: 1px solid #EBEEF5;
        }

        .tbName{
            width: 15%;
            background: #FAFAFA;
        }

        .tbContent{
            width: 35%;
        }
    }
    .imgs{
        margin-top: 20px;
        .imgTtl{
          margin-bottom: 10px
        }
    }
}

</style>



// WEBPACK FOOTER //
// infoText.vue?1ca57cfc